var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-16 h-16 border-4 border-[#069550] border-solid rounded-full animate-spin border-t-transparent"})
}
var staticRenderFns = []

export { render, staticRenderFns }